import { Form, Input } from 'antd';
import styled from 'styled-components';

export const StatusWrap = styled.div`
  display: flex;
  margin: 15px 0px 24px 0px;
  align-items: flex-end;
`;
export const StatusLabel = styled.p`
  font-weight: bold;
  margin: 0;
  font-size: 16px;
`;
export const StatusValue = styled.p`
  margin: 0;
  margin-left: 12px;
`;

export const FormContentWrap = styled.div`
  width: 100%;
`;
export const EmailWrap = styled.div`
  max-width: 360px;
  width: 100%;
  margin-bottom: 24px;
`;
export const FormItem = styled(Form.Item)`
  .ant-form-item-label label {
    font-size: 16px;
  }
  &.toggleWrap {
    max-width: 360px;
    width: 100%;
    display: flex;
    justify-content: end;
  }
`;
export const EmailFigCaptionWrap = styled.div`
  display: flex;
`;

export const FigCaption = styled.p`
  margin: 0;
  padding: 0;
  color: #0c5992;
  font-style: italic;
`;
export const LicenseInputWrap = styled.div`
  display: flex;
  align-items: center;
`;

export const InputWrap = styled(Input)`
  background-color: inherit;
`;
export const LicenseKeyWrap = styled.div`
  width: 100%;
`;
